import ufeApi from 'services/api/ufeApi';
import userUtils from 'utils/User';

function getBiActivityPoints(profileId, pageSize = 10, pageNumber = 1) {
    const biAccountId = userUtils.getBiAccountId();
    const path = `/gway/v1/lxs/${biAccountId}/point-activity-groups`;
    // const url = `${ path }?pageSize=${ pageSize }&pageNumber=${ pageNumber }`;
    const url = `${ path }?pageSize=${ pageSize }&pageNumber=${pageNumber}`;
    const headers = {
        'x-requested-source': 'web'
    };

    return ufeApi.makeRequest(url, { method: 'GET', headers }).then(data => {
        return ((!data || data.errorCode || data?.responseStatus === 500) ? Promise.reject(data) : data);
    });
    // return new Promise((resolve, reject) => {
    //     setTimeout(() => {
    //         // eslint-disable-next-line prefer-promise-reject-errors
    //         // reject({ errorCode: 0 });
    //         resolve({
    //             'total': 10,
    //             'pageNumber': 1,
    //             'pageSize': 10,
    //             'totalPages': 1,
    //             'records': [
    //                 {
    //                     'groupId': '5-279180287434',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora.com',
    //                     'netGroupPoints': -26.0,
    //                     'digitalOrderId': '279180287434',
    //                     'channel': 'ATG',
    //                     'displayDigitalOrderIdAsLink': false,
    //                     'orderDate': '2025-04-27T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-04-27T00:00:00-07:00',
    //                             'activityTypeCode': 'CREATE',
    //                             'description1': 'Base Purchase Points',
    //                             'pointsUpdated': 26.0
    //                         },
    //                         {
    //                             'activityDate': '2025-04-27T00:00:00-07:00',
    //                             'activityTypeCode': 'REDEEM',
    //                             'description1': 'Birthday Gift',
    //                             'pointsUpdated': 0.0,
    //                             'rewardName': 'Birthday Gift',
    //                             'sku': {
    //                                 'transactionDate': 0,
    //                                 'skuId': '2911741'
    //                             }
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '45-279180287434',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Kohls.com',
    //                     'netGroupPoints': 35.0,
    //                     'digitalOrderId': '279180287434',
    //                     'channel': 'KOHLS_ONLINE',
    //                     'displayDigitalOrderIdAsLink': true,
    //                     'orderDate': '2025-10-05T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-10-05T00:00:00-07:00',
    //                             'activityTypeCode': 'CREATE',
    //                             'description1': 'Base Purchase Points',
    //                             'pointsUpdated': 35.0
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '20251005-123-45-67890',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora Kohl\'s Conroe',
    //                     'netGroupPoints': 22.0,
    //                     'channel': 'KOHLS_STORE',
    //                     'displayDigitalOrderIdAsLink': false,
    //                     'orderDate': '2025-10-05T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-10-05T00:00:00-07:00',
    //                             'activityTypeCode': 'CREATE',
    //                             'description1': 'Base Purchase Points',
    //                             'pointsUpdated': 22.0
    //                         },
    //                         {
    //                             'activityDate': '2025-10-05T00:00:00-07:00',
    //                             'activityTypeCode': 'REDEEM',
    //                             'description1': 'Birthday Gift',
    //                             'pointsUpdated': 0.0,
    //                             'rewardName': 'Birthday Gift',
    //                             'sku': {
    //                                 'transactionDate': 0,
    //                                 'skuId': '2911741'
    //                             }
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '20251005-456-45-67890',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora BEACHWOOD',
    //                     'netGroupPoints': 22.0,
    //                     'channel': 'POS',
    //                     'displayDigitalOrderIdAsLink': false,
    //                     'orderDate': '2025-10-05T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-10-05T00:00:00-07:00',
    //                             'activityTypeCode': 'CREATE',
    //                             'description1': 'Base Purchase Points',
    //                             'pointsUpdated': 22.0
    //                         }
    //                     ],
    //                     'tierRequalificationMessage': 'Bi Status Update: VIB Rouge Requalification'
    //                 },
    //                 {
    //                     'groupId': '5-724808927432',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora.com',
    //                     'netGroupPoints': 26.0,
    //                     'digitalOrderId': '724808927432',
    //                     'channel': 'ATG',
    //                     'displayDigitalOrderIdAsLink': true,
    //                     'orderDate': '2025-04-12T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-04-12T00:00:00-07:00',
    //                             'activityTypeCode': 'CREATE',
    //                             'description1': 'Base Purchase Points',
    //                             'pointsUpdated': 23.0
    //                         },
    //                         {
    //                             'activityDate': '2025-04-12T00:00:00-07:00',
    //                             'activityTypeCode': 'REDEEM',
    //                             'description1': 'Beauty Insider Cash',
    //                             'description2': '$20 off for 1000pts',
    //                             'pointsUpdated': -1000.0,
    //                             'rewardName': 'CBR_20_1000'
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '5-724808927433',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora.com',
    //                     'netGroupPoints': 26.0,
    //                     'digitalOrderId': '724808927433',
    //                     'channel': 'ATG',
    //                     'displayDigitalOrderIdAsLink': true,
    //                     'orderDate': '2025-04-12T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-04-12T00:00:00-07:00',
    //                             'activityTypeCode': 'CREATE',
    //                             'description1': 'Base Purchase Points',
    //                             'pointsUpdated': 23.0
    //                         },
    //                         {
    //                             'activityDate': '2025-04-12T00:00:00-07:00',
    //                             'activityTypeCode': 'REDEEM',
    //                             'description1': 'Rouge Reward',
    //                             'description2': '$100 off for 2500 pts',
    //                             'pointsUpdated': -2500.0,
    //                             'rewardName': 'CBR_20_1000'
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '20250323-456-45-67890',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora BEACHWOOD',
    //                     'netGroupPoints': -77.0,
    //                     'channel': 'POS',
    //                     'displayDigitalOrderIdAsLink': false,
    //                     'orderDate': '2025-03-23T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'CREATE',
    //                             'description1': 'Base Purchase Points',
    //                             'pointsUpdated': 23.0
    //                         },
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'REDEEM',
    //                             'pointsUpdated': -100.0,
    //                             'rewardName': 'BI_100_POINTS',
    //                             'sku': {
    //                                 'transactionDate': 0,
    //                                 'skuId': '123456',
    //                                 'displayName': 'Tower 28 Beauty',
    //                                 'url': 'https://www.sephora.com/product/sos-faceguard-spf-30-P479234',
    //                                 'displayText': 'SOS FaceGuard SPF 30...'
    //                             }
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '5-724808927432',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora.com',
    //                     'netGroupPoints': -77.0,
    //                     'digitalOrderId': '724808927432',
    //                     'channel': 'ATG',
    //                     'displayDigitalOrderIdAsLink': true,
    //                     'orderDate': '2025-03-23T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'CREATE',
    //                             'description1': 'Base Purchase Points',
    //                             'pointsUpdated': 23.0
    //                         },
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'REDEEM',
    //                             'pointsUpdated': -100.0,
    //                             'rewardName': 'BI_100_POINTS',
    //                             'sku': {
    //                                 'transactionDate': 0,
    //                                 'skuId': '123456',
    //                                 'displayName': 'Tower 28 Beauty',
    //                                 'url': 'https://www.sephora.com/product/sos-faceguard-spf-30-P479234',
    //                                 'displayText': 'SOS FaceGuard SPF 30...'
    //                             }
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '5-724808927432',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora.com',
    //                     'netGroupPoints': 123.0,
    //                     'digitalOrderId': '724808927432',
    //                     'channel': 'ATG',
    //                     'displayDigitalOrderIdAsLink': true,
    //                     'orderDate': '2025-04-12T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-04-12T00:00:00-07:00',
    //                             'activityTypeCode': 'CREATE',
    //                             'description1': 'Base Purchase Points',
    //                             'pointsUpdated': 23.0
    //                         },
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'GAME_POINT_CREDIT',
    //                             'description1': 'Beauty Insider Challenge',
    //                             'description2': 'Purchase a Hair product',
    //                             'pointsUpdated': 100.0
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '13579',
    //                     'groupType': 'NON_ORDER',
    //                     'groupDescription': 'Sephora.com',
    //                     'netGroupPoints': 100.0,
    //                     'displayDigitalOrderIdAsLink': false,
    //                     'orderDate': '2025-04-12T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-04-12T00:00:00-07:00',
    //                             'activityTypeCode': 'GAME_POINT_CREDIT',
    //                             'description1': 'Beauty Insider Challenge',
    //                             'description2': 'Purchase a Hair product',
    //                             'pointsUpdated': 100.0
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '5-724808927432',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora.com',
    //                     'netGroupPoints': 236.0,
    //                     'digitalOrderId': '724808927432',
    //                     'channel': 'ATG',
    //                     'displayDigitalOrderIdAsLink': true,
    //                     'orderDate': '2025-03-23T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'CREATE',
    //                             'description1': 'Base Purchase Points',
    //                             'pointsUpdated': 59.0
    //                         },
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'EXTRA_POINT_PROMO_CREDIT',
    //                             'description1': '4x Sephora Collection Bonus Points',
    //                             'pointsUpdated': 177.0
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '20250323-456-45-67890',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora Powell Street',
    //                     'netGroupPoints': 77.0,
    //                     'channel': 'POS',
    //                     'displayDigitalOrderIdAsLink': false,
    //                     'orderDate': '2025-04-27T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-04-27T00:00:00-07:00',
    //                             'activityTypeCode': 'RETURN',
    //                             'description1': 'Store Return',
    //                             'pointsUpdated': -26.0
    //                         },
    //                         {
    //                             'activityDate': '2025-04-27T00:00:00-07:00',
    //                             'activityTypeCode': 'REVOKE',
    //                             'pointsUpdated': 100.0,
    //                             'rewardName': 'BI_100_POINTS',
    //                             'sku': {
    //                                 'transactionDate': 0,
    //                                 'skuId': '123456',
    //                                 'displayName': 'Tower 28 Beauty',
    //                                 'url': 'https://www.sephora.com/product/sos-faceguard-spf-30-P479234',
    //                                 'displayText': 'SOS FaceGuard SPF 30...'
    //                             }
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '5-724808927432',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora.com',
    //                     'netGroupPoints': 77.0,
    //                     'digitalOrderId': '724808927432',
    //                     'channel': 'ATG',
    //                     'displayDigitalOrderIdAsLink': true,
    //                     'orderDate': '2025-03-23T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'RETURN',
    //                             'description1': 'Base Purchase Points',
    //                             'pointsUpdated': -23.0
    //                         },
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'REVOKE',
    //                             'pointsUpdated': 100.0,
    //                             'rewardName': 'BI_100_POINTS',
    //                             'sku': {
    //                                 'transactionDate': 0,
    //                                 'skuId': '123456',
    //                                 'displayName': 'Tower 28 Beauty',
    //                                 'url': 'https://www.sephora.com/product/sos-faceguard-spf-30-P479234',
    //                                 'displayText': 'SOS FaceGuard SPF 30...'
    //                             }
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '5-724808927432',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora.com',
    //                     'netGroupPoints': 38.0,
    //                     'digitalOrderId': '724808927432',
    //                     'channel': 'ATG',
    //                     'displayDigitalOrderIdAsLink': true,
    //                     'orderDate': '2025-03-23T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'CREATE',
    //                             'description1': 'Base Purchase Points',
    //                             'pointsUpdated': 38.0
    //                         },
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'REDEEM',
    //                             'pointsUpdated': -100.0,
    //                             'rewardName': 'BI_100_POINTS',
    //                             'sku': {
    //                                 'transactionDate': 0,
    //                                 'skuId': '123456',
    //                                 'displayName': 'Tower 28 Beauty',
    //                                 'url': 'https://www.sephora.com/product/sos-faceguard-spf-30-P479234',
    //                                 'displayText': 'SOS FaceGuard SPF 30...'
    //                             }
    //                         },
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'REVOKE',
    //                             'pointsUpdated': 100.0,
    //                             'rewardName': 'BI_100_POINTS',
    //                             'sku': {
    //                                 'transactionDate': 0,
    //                                 'skuId': '123456',
    //                                 'displayName': 'Tower 28 Beauty',
    //                                 'url': 'https://www.sephora.com/product/sos-faceguard-spf-30-P479234',
    //                                 'displayText': 'SOS FaceGuard SPF 30...'
    //                             }
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '5-724808927432',
    //                     'groupType': 'ORDER',
    //                     'groupDescription': 'Sephora.com',
    //                     'netGroupPoints': 0.0,
    //                     'digitalOrderId': '724808927432',
    //                     'channel': 'ATG',
    //                     'displayDigitalOrderIdAsLink': true,
    //                     'orderDate': '2025-03-23T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'REDEEM',
    //                             'pointsUpdated': -100.0,
    //                             'rewardName': 'BI_100_POINTS',
    //                             'sku': {
    //                                 'transactionDate': 0,
    //                                 'skuId': '123456',
    //                                 'displayName': 'Tower 28 Beauty',
    //                                 'url': 'https://www.sephora.com/product/sos-faceguard-spf-30-P479234',
    //                                 'displayText': 'SOS FaceGuard SPF 30...'
    //                             }
    //                         },
    //                         {
    //                             'activityDate': '2025-03-23T00:00:00-07:00',
    //                             'activityTypeCode': 'REVOKE',
    //                             'pointsUpdated': 100.0,
    //                             'rewardName': 'BI_100_POINTS',
    //                             'sku': {
    //                                 'transactionDate': 0,
    //                                 'skuId': '123456',
    //                                 'displayName': 'Tower 28 Beauty',
    //                                 'url': 'https://www.sephora.com/product/sos-faceguard-spf-30-P479234',
    //                                 'displayText': 'SOS FaceGuard SPF 30...'
    //                             }
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     'groupId': '24680',
    //                     'groupType': 'NON_ORDER',
    //                     'groupDescription': 'Sephora Customer Service',
    //                     'netGroupPoints': 100.0,
    //                     'displayDigitalOrderIdAsLink': false,
    //                     'orderDate': '2025-10-16T00:00:00-07:00',
    //                     'orderStatus': 'ABC',
    //                     'pointActivities': [
    //                         {
    //                             'activityDate': '2025-10-16T00:00:00-07:00',
    //                             'activityTypeCode': 'LOYALTY_POINTS_UPDATE',
    //                             'description1': 'Beauty Insider point Update',
    //                             'pointsUpdated': 100.0
    //                         }
    //                     ]
    //                 }
    //             ]
    //         });
    //     }, 5000);
    // });
}

export default getBiActivityPoints;
